import { Icon } from "@iconify/react";
import vscodeFileTypePdf2 from "@iconify-icons/vscode-icons/file-type-pdf2";

const defaultSize = 36;

export function VscodeFileTypePdf2Icon(props: { size?: number }) {
  const { size = defaultSize } = props;
  return <Icon icon={vscodeFileTypePdf2} width={size} height={size} aria-hidden />;
}
